import { get } from '../../Common/utils';
import { visitStatusLabels } from '../constants';

const businessFactory = ({ totals = [] }) =>
  totals.map(total => ({
    agencyName: get(total, 'agencyName', ''),
    aggregatorID: get(total, 'aggregatorID', ''),
    partnerName: get(total, 'partnerName', ''),
    totalTransactions: get(total, 'TotalTransactions', ''),
    totalErrors: get(total, 'TotalErrors', ''),
    totalPending: get(total, 'TotalPending', ''),
    totalSuccess: get(total, 'ProcessingSuccess', ''),
    visitType: visitStatusLabels[get(total, 'visitStatus', '')],
  }));

const getBusinessTotalRecords = ({ totalRecords = 0 }) => totalRecords;

const normalizeBusiness = response => ({
  business: businessFactory(response),
  totalRecords: getBusinessTotalRecords(response),
});

const normalizeBusinessReportsError = ({ message = {} }) => {
  const errors = get(message, 'messages', []);

  return {
    errors,
  };
};

const normalizePartners = ({ partners = [] }) =>
  [{ label: 'All', value: 'ALL' }].concat(
    partners.map(agency => ({
      label: get(agency, 'name', ''),
      value: get(agency, 'partnerID', ''),
    })),
  );

const normalizeAggregators = (aggregators = []) =>
  [{ label: 'All', value: 'ALL' }].concat(
    aggregators.map(agency => ({
      label: get(agency, 'aggregatorID', ''),
      value: get(agency, 'aggregatorID', ''),
    })),
  );

export {
  normalizeBusiness,
  normalizeAggregators,
  normalizePartners,
  normalizeBusinessReportsError,
};
